import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard-component-editor',
  standalone: false,
  templateUrl: './dashboard-component-editor.component.html',
  styleUrl: './dashboard-component-editor.component.scss'
})
export class DashboardComponentEditorComponent {

}
